import { z } from 'zod';
import { HttpErrorResponse } from '../common/validation-error';
const EmailToken = z.string().min(1);
const LearningPlanStatus = z.enum(['not-started', 'in-progress', 'completed']);
const StaticLearningPlanUnit = z.discriminatedUnion('type', [
    z.object({
        status: LearningPlanStatus,
        reasoning: z.string(),
        slug: z.string(),
        type: z.literal('project'),
        project: z
            .object({
            slug: z.string(),
            name: z.string(),
            description: z.string(),
            imageUrl: z.string(),
            topic: z.string(),
            questionCount: z.number(),
            tags: z.array(z.string()),
        })
            .passthrough(),
    }),
    z.object({
        status: LearningPlanStatus,
        reasoning: z.string(),
        slug: z.string(),
        type: z.literal('content-module'),
        content: z
            .object({
            id: z.number(),
            title: z.string(),
            slug: z.string(),
            imageUrl: z.string(),
            description: z.string(),
            topic: z.string(),
            lessonsCount: z.number(),
        })
            .passthrough(),
    }),
]);
const PublicUpsellResponse = z.object({
    // User is a legacy database payload shared with the learner app.
    user: z.record(z.unknown()),
    learningPlan: z.array(StaticLearningPlanUnit).nullable(),
    planExplanation: z
        .object({
        summary: z.string(),
        milestones: z.array(z.string()),
    })
        .nullable(),
    shouldGetTrial: z.boolean(),
    hasSubscription: z.boolean(),
});
export const getProsumerUpsellPublicRoute = {
    version: 1,
    method: 'GET',
    path: '/prosumer/upsell-public',
    name: 'get-prosumer-upsell-data-public',
    request: { query: z.object({ emailToken: EmailToken }) },
    responses: { 200: PublicUpsellResponse, 400: HttpErrorResponse },
};
export const unsubscribeProsumerRoute = {
    version: 1,
    method: 'POST',
    path: '/prosumer/unsubscribe',
    name: 'unsubscribe-prosumer-preferences',
    request: { body: z.object({ emailToken: EmailToken }) },
    responses: { 200: z.object({}), 400: HttpErrorResponse },
};
